module.exports = __webpack_public_path__ + "img/999.b0fa0d32.png";